<template>
  <!-- comentario 1 -->
  <div id="app" class="min-h-screen bg-gray-200 font-sans">
    <a-layout class="bg-gray-200">
      <a-layout-header class="h-auto px-8 sm:px-16 bg-blue-500">
        <a-col flex="300px" align="middle" class="float-none block md:float-left">
          <div class="m-2 w-auto h-20 cursor-pointer" @click.prevent="navigateHome">
            <picture>
              <source class="max-h-20" srcset="/img/logo.avif" type="image/avif" />
              <source class="max-h-20" srcset="/img/logo.webp" type="image/webp" />
              <img class="max-h-20" src="@/assets/img/logo.png" alt="logo" title="Libertad" />
            </picture>
          </div>
        </a-col>
        <a-col v-if="isHomeRoute" flex="auto" align="middle" class="float-none block md:float-right">
          <!-- <p class="text-center font-bold w-full text-base text-white">¿Ya cuentas con una solicitud registrada? Ingresa tu folio y continúa:</p> -->
          <a-col class="m-2 object-center" style="padding-top: 20px">
            <!-- <p class="pl-0 md:pl-8 w-auto text-base md:text-2xl font-bold text-white pt-2 md:float-left">Folio</p> -->
            <a-input
              v-model="folio"
              v-show="inputFolio === 'Folio'"
              class="block w-48 md:w-64 h-10 mx-2 rounded-lg bg-yellow-500 text-base md:text-lg font-bold border-0 text-white align-middle hover:bg-yellow-600 hover:text-white justify-center md:float-left"
              placeholder="Ingrese su información"
              size="large"
              allow-clear
            />
            <a-button
              v-show="inputFolio === 'Folio'"
              @click.prevent="findLead"
              :loading="isBusy"
              class="block w-48 md:w-16 h-10 mx-2 rounded-lg bg-yellow-500 text-base md:text-lg font-bold border-0 text-white align-middle hover:bg-yellow-600 hover:text-white justify-center md:float-left"
            >
              <!-- :confirm-loading="isCodeConfirmationBusy" -->
              <!-- <a-icon type="check" /> -->
              Ir
            </a-button>
            <a-button
              v-show="inputFolio !== 'Folio'"
              type="secondary"
              class="block w-48 md:w-64 h-10 mx-2 rounded-lg bg-yellow-500 text-base md:text-md font-bold border-0 text-white align-middle hover:bg-yellow-600 hover:text-white justify-center md:float-left"
              @click.prevent="showFolio"
              :loading="isBusy"
            >
              Ingresa tu Folio
            </a-button>
          </a-col>
          <p class="text-left text-base text-white md:pt-10 md:ml-4" v-show="inputFolio === 'Folio'">
            Da click <strong class="text-white underline cursor-pointer" @click.prevent="showFolioRecovery = true">aquí</strong>, si no recuerdas tu folio.
          </p>
        </a-col>
        <a-col v-if="login" flex="auto" align="middle" class="float-none block md:float-right">
          <auto-logout v-if="login" @changed="logOut" :time="timeAutoLogout" />
          <a-button
            class="block w-48 md:w-64 h-10 mx-2 rounded-lg bg-yellow-500 text-base md:text-lg font-bold border-0 text-white align-middle hover:bg-yellow-600 hover:text-white justify-center md:float-right md:mt-3"
            v-on:click="logOut"
            >Logout</a-button
          >
          <div class="flex flex-col">
            <p class="text-right text-base text-white md:pt-5 md:ml-4">{{ email }}</p>
            <p v-if="isPLD" class="text-right text-base text-white md:pt-1 md:ml-4 font-bold"> ⚠️{{ mensajeCoincidenciaPLD }} </p>
          </div>
        </a-col>
      </a-layout-header>
      <div class="py-1 bg-yellow-500"></div>
      <router-view />
      <a-layout-footer class="text-center bg-gray-200">
        <div id="nav" v-if="isDevelopment">
          <router-link to="/">Home</router-link> | <router-link to="/dev/colors">Color Palette</router-link> | <router-link to="/dev/controls">Controls</router-link>
        </div>
        <p>{{ $t("general.copyright") }}</p>
        <p>v2.0.3.0</p>
      </a-layout-footer>
      <a-modal
        v-model="showFolioRecovery"
        title="¿Olvidaste tu folio?"
        @ok.prevent="sendFolioRecovery"
        @cancel.prevent="showFolioRecovery = false"
        cancelText="Cancelar"
        okText="Enviar SMS"
        :confirm-loading="isRecoverFolioBusy"
        :cancelButtonProps="{ props: { disabled: isRecoverFolioBusy } }"
      >
        <p>Ingresa el número telefónico registrado en tu solicitud y te enviaremos un SMS con tu folio.</p>
        <a-input class="mt-2 border border-gray-400 rounded-lg" v-model="recoveryMobile" type="tel" placeholder="Número de teléfono móvil" size="large" :max-length="10" allow-clear v-numeric-only>
          <a-tooltip slot="suffix" title="Número telefónico a 10 digitos">
            <a-icon type="info-circle" style="color: rgba(0, 0, 0, 0.45)" />
          </a-tooltip>
        </a-input>
        <a-alert class="mt-2" v-if="recoveryMobileInvalid" type="error" message="El número telefónico no es válido" closable @close="recoveryMobileInvalid = false" />
      </a-modal>
    </a-layout>
  </div>
</template>

<script lang="ts">
import { Component, Watch, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { leadService } from "@/services/lead.service";
import { catalogueService } from "@/services/catalogue.service";
import { aesEncrypt, isEmpty } from "@/utils";
import { DecryptAes } from "@/utils/cryptohelper";
import { LEAD_ADD_FOLIO, SYSTEM_USER, EMAIL, USER_PORTAL, SESSION_ID } from "@/store/types";
import { variablesService } from "@/services/variables.service";
import { PurposeResponse } from "@/models/responses/purpose.interface";
// import authentication from "./services/authentication";
import { userService } from "./services/user.service";
import AutoLogout from "./components/AutoLogout.vue";
import { TimeAutoLogout } from "./models/requests/user.interface";
import { opportunityService } from "./services/opportunity.service";

@Component({
  components: {
    AutoLogout
  }
})
export default class App extends Vue {
  login = false;
  isBusy = false;
  folio = "";
  isHomeRoute = false;
  // showCodeConfirmation = false;
  inputFolio = "Boton";

  showFolioRecovery = false;
  isRecoverFolioBusy = false;
  recoveryMobile = "";
  recoveryMobileInvalid = false;

  email = "";
  name = "";
  idU = "";

  purposes: PurposeResponse[] = [];

  timeAutoLogout: TimeAutoLogout = {
    warning: 0,
    logout: 0
  };
  mensajeCoincidenciaPLD = "";

  get isDevelopment(): boolean {
    return process.env.NODE_ENV === "development";
  }

  @Watch("$route.name")
  onRouteChanged(name: string): void {
    this.isHomeRoute = name == "Home";

    const email = this.$store.getters.getMail;
    const user = this.$store.getters.getUser;
    if (email && user) {
      this.login = true;
      this.email = email;
    } else {
      this.login = false;
    }
  }

  // showModalFolio(): void {
  //   this.showCodeConfirmation = true;
  // }

  showFolio(): void {
    this.inputFolio = "Folio";
  }

  navigateHome(): void {
    if (this.isHomeRoute) return;
    this.$router.push({ name: "Home" });
  }

  async sendFolioRecovery(): Promise<void> {
    if (isEmpty(this.recoveryMobile)) {
      this.recoveryMobileInvalid = true;
      return;
    }

    this.recoveryMobileInvalid = false;
    this.isRecoverFolioBusy = true;

    try {
      // await this.$recaptchaLoaded();
      // FIXME: reCaptcha token should be sent to backend along with recovery request
      // That way, backend validates the token before sending SMS and frontend does not know anything about it (it should also validate the action matches)

      // TODO: Se remueve el recatcha.
      // const action = "folio_recovery";
      // const token = await this.$recaptcha(action);

      // const found = await leadService.recoverFolio(this.recoveryMobile, token, action);

      const found = await leadService.recoverFolio(this.recoveryMobile, "", "");
      this.isRecoverFolioBusy = false;
      if (found) {
        this.recoveryMobile = "";
        this.showFolioRecovery = false;
        this.$message.success("Se ha enviado un SMS al número telefónico proporcionado.");
      } else {
        this.$message.error("La petición no puede ser procesada por el momento.");
      }
    } catch (error) {
      this.showError(error);
    }
  }

  async findLead(): Promise<void> {
    if (isEmpty(this.folio)) return;
    if (this.isBusy) return;

    try {
      this.isBusy = true;
      const lead = await leadService.findLeadByFolio(this.folio);
      if (lead) {
        if (lead.projectType == 0) {
          if (lead.clientType == 2) {
            this.goToImss(lead.id, lead.clientType, this.folio);
          } else {
            this.showInfo("La solicitud no puede ser abierta.");
          }
        } else {
          this.goToOriginacion(lead.id, this.folio, "prospecto");
        }
      } else {
        const opportunity = await opportunityService.findOppByFolio(this.folio);
        if (opportunity) {
          if (opportunity.projectType == 0) {
            this.goToImss(opportunity.id, opportunity.clientType, this.folio);
          } else if (opportunity.projectType == 1 && opportunity.clientType == 3) {
            this.goToOriginacion(opportunity.id, this.folio, "oportunidad");
          } else {
            this.showInfo("La solicitud no puede ser abierta.");
          }
        } else {
          /* onst ldFolio = await leadService.createPreauthorizedClient(this.folio);
          if (ldFolio) {
            const lID = await leadService.findByFolio(ldFolio);
            if (lID) {
              this.goToOriginacion(lID, ldFolio);
            } else {
              this.showInfo("La solicitud no se encuentra disponible, favor de acudir a sucursal.");
            }
          } else {
            this.showInfo("La solicitud no se encuentra disponible, favor de acudir a sucursal.");
          } */
          this.showInfo("La solicitud no se encuentra disponible, favor de acudir a sucursal.");
        }
      }
    } catch (error) {
      this.showError(error);
    } finally {
      this.isBusy = false;
    }
  }

  goToImss(ID: string, clientType: number, folio: string): void {
    let entidad = "";

    this.$store.dispatch(LEAD_ADD_FOLIO, folio).then(() => {
      const id = aesEncrypt(ID);
      const code = aesEncrypt(folio);
      const step = aesEncrypt("0");
      if (clientType == 2) {
        entidad = aesEncrypt("prospecto");
      } else {
        entidad = aesEncrypt("oportunidad");
      }
      this.$router.push({
        name: "Imss",
        query: { tracking: id, code: code, s: step, ent: entidad }
      });
    });
  }

  goToOriginacion(ID: string, folio: string, entidad: string): void {
    this.$store.dispatch(LEAD_ADD_FOLIO, folio).then(() => {
      const id = aesEncrypt(ID);
      const code = aesEncrypt(folio);
      const ent = aesEncrypt(entidad);
      this.$router.push({
        name: "Profiling",
        query: { tracking: id, code: code, ent: ent }
      });
    });
  }

  async logOut(): Promise<void> {
    try {
      const resp = await userService.logOut();
      if (resp.code != 200) {
        this.showControlledError(resp.message);
      } else {
        this.$store.dispatch(USER_PORTAL, "");
        this.$store.dispatch(EMAIL, "");
        this.$store.dispatch(SYSTEM_USER, "");
        this.$store.dispatch(SESSION_ID, "");

        const token = localStorage.getItem("tokenPCC");
        if (token) {
          localStorage.removeItem("tokenPCC");
        }
        const user = localStorage.getItem("userPCC");
        if (user) {
          localStorage.removeItem("userPCC");
        }

        this.$router.push({ name: "LogIn" });
      }
    } catch (error) {
      this.showError(error);
    }
  }

  showError(error: any, title?: string): void {
    if (!title) title = "Ocurrió un error";
    let errorTmp;
    if (error?.response?.data?.ValueResponse) {
      const resDecrypt = DecryptAes(error?.response?.data?.ValueResponse) as string;
      const json = JSON.parse(resDecrypt);
      errorTmp = json as Error;
    } else if (error.response?.data?.error) {
      errorTmp = error.response?.data?.error;
    } else {
      errorTmp = error;
    }

    this.$error({
      title: title,
      content: errorTmp?.message,
      centered: true,
      okText: "Aceptar"
    });
  }

  showControlledError(error: string, title?: string): void {
    if (!title) title = "Ocurrió un error";
    this.$error({
      title: "Ocurrió un error",
      content: error,
      centered: true,
      okText: "Aceptar"
    });
  }

  showInfo(info: string): void {
    this.$info({
      title: "",
      content: info,
      centered: true,
      okText: "Aceptar"
    });
  }

  async mounted(): Promise<void> {
    try {
      const time = await variablesService.getEnviromentVariable("rs_PortalCC_VigenciaInicioSesion");
      const json = JSON.parse(time);
      this.timeAutoLogout = json as TimeAutoLogout;

      const isAviable = await variablesService.schedule();

      // const userId = await leadService.getUserId(this.email);
      // this.$store.commit(SYSTEM_USER, userId);

      if (isAviable) {
        this.isHomeRoute = this.$route.name == "Home";
      } else this.$router.push({ name: "NotFound" });

      this.mensajeCoincidenciaPLD = await variablesService.getEnviromentVariable("rs_alertacoincidencia");
    } catch (e) {
      this.showError(e);
    }
  }

  async computed(): Promise<void> {
    // this.isAuthenticated();

    mapGetters([USER_PORTAL, EMAIL, SYSTEM_USER, SESSION_ID]);
  }

  async created(): Promise<void> {
    // if (this.isAuthenticated) this.getProfile();
  }

  // getProfile(): void {
  //   const profile = authentication.getUserProfile();
  //   this.email = profile.upn;
  //   this.$store.commit(EMAIL, this.email);

  //   this.name = profile.name;
  //   this.idU = profile.tid;
  // }

  // isAuthenticated(): boolean {
  //   return authentication.isAuthenticated();
  // }

  // logOut(): void {
  //   authentication.signOut();
  // }

  get isPLD(): boolean {
    return this.$store.getters.getPLDStatus;
  }
}
</script>

<style lang="scss">
#app {
  color: #2c3e50;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

.bg-blue-500 {
  background-color: #004593 !important;
}

.bg-yellow-500 {
  background-color: #fab400 !important;
}

.bg-gray-200 {
  background-color: #fff !important;
}

.text-blue-500 {
  color: #004593 !important;
}

#nav {
  padding: 30px;

  a {
    color: #2c3e50;
    font-weight: bold;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.ant-slider-rail {
  background-color: #e1e1e1 !important;
}
</style>
